import { Button } from "components/Form";
import React from "react";
import "./Quantity.scss";
export function Increment({ increment }) {
    return (React.createElement(Button, { type: "button", onClick: increment, buttonName: "+", className: "k-quantity--increase increment" }));
}
